<template>
    <el-dialog title="选择考核" :visible.sync="dialogVisible" :close-on-click-modal="false" width="80rem">
        <examine-score-detail ref="examine_score_detail"></examine-score-detail>
        <theory-detail :detail="detail" ref="theory_detail"></theory-detail>
        <div class="soft-box">
            <Table :totalSize="tableData.length" :pagination="false" :operationWidth="350" :currentPage="pages.current"
                :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                <template slot="operation" slot-scope="data">
                    <!-- <div class="btn-button" :class="{'disable-button':data.data.row.examineStatus=='2'}"  @click="startTask(data.data.row)">开始任务</div>       -->
                    <div class="btn-button disable-button" v-if="['0','3'].includes(data.data.row.examineStatus)&&isTimeArea(data.data.row.beginTime, data.data.row.endTime)">开始任务</div>
                    <div class="btn-button" v-else-if="['1', null].includes(data.data.row.examineStatus)&&isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                        @click="startTask(data.data.row)">开始任务</div>
                    <!-- <div class="btn-button disable-button"
                        v-else-if="data.data.row.examineStatus == '2' && !isTimeArea(data.data.row.beginTime, data.data.row.endTime)">
                        查看详情</div> -->
                    <div class="btn-button" v-else-if="!isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                        @click="viewScoreDetail(data.data.row)">查看详情</div>
                </template>
                <template slot="type" slot-scope="data">
                    <div>{{ filterType[data.data.row.type] }}</div>
                </template>
            </Table>
        </div>
    </el-dialog>
</template>

<script>
import { PushExamineRecord, GetSoftwareScoreTree } from '@/api/examine';
import { GetUserAnswerRecord, GetTestPaperQuestion } from '@/api/paper';
import { isTimeArea } from '@/utils/utils';
import ExamineScoreDetail from './ExamineScoreDetail.vue';
import TheoryDetail from './TheoryDetail.vue';
export default {
    components: { ExamineScoreDetail, TheoryDetail },
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            /**任务Id */
            taskId: '',
            filterType: {
                0: '理论',
                1: '软件'
            },
            /**考核类型 */
            examineType: '',
            pages: {
                current: 1,
                size: 10,
            },
            optSource: '',
            tableKey: [
                {
                    name: '名称',
                    value: 'name'
                },
                {
                    name: '考核类型',
                    value: 'type',
                    slot: 'type'
                },
                {
                    name: '软件类型',
                    value: 'resType'
                },
                {
                    name: '',
                    value: 'operation',
                    slot: 'operation'
                },
            ],
            detail: {},
            recordId: '',
        }
    },
    methods: {
        isTimeArea(beginTime,endTime){
            console.log(isTimeArea(beginTime,endTime),'zz')
            return isTimeArea(beginTime,endTime);
        },
        startTask(item) {
            if (item.examineStatus == '2') {
                return;
            }
            if (item.type == '0') {
                var href = window.location.origin + `/theoryTest?id=${item.id}&examineId=${this.taskId}`;
                window.open(href, '_blank');
            } else {
                if (item.resType == '单机') {
                    if (!item.regedit) {
                        this.$msg({
                            showClose: true,
                            message: "暂无资源",
                            type: "warning",
                        });
                        return;
                    }
                    detectProtocol(item.regedit + '://', () => {
                        console.log("未找到协议.");
                        this.$confirm("未检测到软件，立即下载。", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        })
                            .then(() => {
                                if (item.fileId) {
                                    getFileInfo(item.fileId).then(res => {
                                        if (res.code == 200) {
                                            var src = this.$severUrl(res.data.fileUrl);
                                            var link = document.createElement('a');
                                            link.href = src;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }
                                    })
                                } else {
                                    this.$msg({
                                        showClose: true,
                                        message: "暂无资源",
                                        type: "warning",
                                    });
                                }
                            })
                            .catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消下载"
                                });
                            });
                    },
                        () => {
                            console.log("找到自定义协议并成功打开文件.");
                        },
                        1000
                    );
                } else {
                    let params = {
                        "examineId": this.taskId,
                        "examineType": '2',
                        "resourceId": item.id,
                        "type": 0
                    };
                    PushExamineRecord(params).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('businessId', this.taskId + '-' + item.id);
                            let href = window.location.origin + `/virtualTest?url=${item.url}&optSource=${this.optSource}&businessId=${this.taskId + '-' + item.id}`;
                            window.open(href, '_blank');
                        }
                    })
                }
            }
        },
        /**获取试卷题目数据 */
        getTestPaperQuestion(paperId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": this.taskId + '-' + paperId,
                    "testPaperId": paperId,
                    "testPaperRecordId": this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.detail = res.data;
                        let dialog = this.$refs.theory_detail;
                        if (dialog) {
                            dialog.dialogVisible = true;
                        }
                        resolve(res.data);
                    }
                })
            })
        },
        /**获取用户答题记录 */
        getUserAnswerRecord(paperId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": this.taskId + '-' + paperId,
                    "testPaperId": paperId,
                    "testPaperSource": 'examine_paper'
                }
                GetUserAnswerRecord(params).then(async (res) => {
                    if (res.code == 200) {
                        this.recordId = res.data.id;
                        await this.getTestPaperQuestion(paperId);
                        this.$set(this.detail, 'userQuestionScoreVOS', res.data.userQuestionScoreVOS);
                        let startTime = new Date(res.data.startTime).getTime();
                        let endTime = new Date(res.data.endTime).getTime();
                        let userTestTime = (endTime - startTime) / 1000;
                        this.$set(this.detail, 'userTestTime', userTestTime);
                        let questionDetailVOS = this.detail.questionDetailVOS;
                        res.data.userQuestionScoreVOS && res.data.userQuestionScoreVOS.forEach(item => {
                            var data = questionDetailVOS[item.questionType];
                            var userAnswer = item.userAnswer || [];
                            if (data) {
                                let e = data.find(el => el.questionId == item.questionId);
                                if (e) {
                                    this.$set(e, 'correctAnswer', item.correctAnswer || []);
                                    this.$set(e, 'score', item.score || 0);
                                    this.$set(e, 'content', item.content || '暂无');
                                    var questionType = item.questionType;
                                    if (questionType == '多选题') {
                                        e.value = userAnswer;
                                    } else if (questionType == '填空题') {
                                        e.questionOptionVOS.forEach((a, b) => {
                                            a.value = userAnswer[b] ? userAnswer[b] : '';
                                        })
                                    } else {
                                        e.value = userAnswer[0] ? userAnswer[0] : '';
                                    }
                                }
                            }
                        })
                        resolve(res.data);
                    }
                })
            })
        },
        /**查看得分详情 */
        viewScoreDetail(data) {
            if (data.type == '1') {
                let params = {
                    examineId: this.taskId,
                    softwareId: data.id,
                    userId: this.$store.state.user.userInfo.id
                }
                GetSoftwareScoreTree(params).then(res => {
                    let dialog = this.$refs.examine_score_detail;
                    if (dialog) {
                        dialog.dialogVisible = true;
                        dialog.detail = res.data;

                    }
                });
            } else {
                this.getUserAnswerRecord(data.id);
            }
        },
    }
}
</script>

<style lang="less" scoped>
.soft-box {
    height: 50rem;
    overflow: auto;
}

.btn-button {
    width: 72px;
    height: 26px;
    background: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
}

.disable-button {
    cursor: not-allowed !important;
    background-color: #C0C4CC !important;
}

/deep/.el-dialog {
    border-radius: 1rem;
}

/deep/.el-dialog__header {
    font-weight: 700;
    padding: 3rem 5rem;
}

/deep/.el-dialog__body {
    padding: 0 3rem 5rem 3rem;
}
</style>